// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-b997b998]{height:120px;width:100%;text-align:center;padding:32px 0 20px;background:#000}.footer-title[data-v-b997b998]{font-size:16px;line-height:22px;margin-bottom:12px}.footer .navs[data-v-b997b998]{margin-bottom:47px}.footer .navs .nav[data-v-b997b998]{display:inline-block;padding-left:14px;font-size:12px;color:#fff;line-height:12px}.footer .navs .nav[data-v-b997b998]:last-child{border-right:0}.footer-title[data-v-b997b998]{font-size:12px;color:#fff}", ""]);
// Exports
module.exports = exports;
